import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'auth_by_contract_epargn_sms.title',
  },
  subTitle: {
    id: 'auth_by_contract_epargn_sms.sub_title',
  },
  email: {
    id: 'id_memo.email',
  },
  validationErrorMessage: {
    id: 'signup_personal_info.email.error',
  },
  requiredField: {
    id: 'required.field',
  },
  suivant: {
    id: 'signup_auth_button.next',
  },
  precedent: {
    id: 'signup_auth_button.previous',
  },
});
